module.exports = __webpack_public_path__ + "logo-shopify.2ca9797566fa19890c9e34d1b468f540.svg";